import React from "react";
import Image from "next/image";
import { FormHeading, SuccessMessageType } from "@/interface/types";
import EnqueryForm from "@/components/forms/EnqueryForm";

const UspPoweredMilesDesktop: React.FC = () => {
  return (
    <>
      <div className="w-full md:py-16 py-8 relative bg-[#0C1F33]">
        <Image
          quality={50}
          src="/cpa/bg_mils.png"
          alt="Accountants "
          className="cursor-pointer absolute bottom-0 left-0 z-[1]"
          width={840}
          height={480}
        />
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 px-5 ">
          <div className="flex justify-between items-center relative z-[9] flex-wrap">
            <div>
              <h2 className="font-bold md:text-[#FFBA08] text-[#FDA549] 2xl:text-[76px] md:text-[60px] text-[28px] md:text-left text-center leading-[1.1] mb-8">
                Your Pathway <br className="md:block hidden" /> to the US.
                <br className="md:block hidden" /> Powered by{" "}
                <br className="md:block hidden" /> Miles
              </h2>
            </div>
            <div className="w-full md:w-auto relative flex items-center justify-center">
              <div
                className="w-full md:w-[420px] p-4 border border-white rounded-2xl"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
                  boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
                  backdropFilter: "blur(28px)",
                }}
              >
                <Image
                  src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                  alt="star group"
                  width={34}
                  height={38}
                  className="absolute top-1 left-0"
                />
                <EnqueryForm
                  pageName="USP"
                  courseId={3}
                  darkBackground={true}
                  submitButtonName="Request a Callback"
                  formType="Banner Form"
                  isAStepperForm
                  successMessage={SuccessMessageType.ACCOUNTING}
                  formHeading={FormHeading.TALK_TO_AN_EXPERT}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UspPoweredMilesDesktop;
